import CryptoJS from 'crypto-js'

const key = 'sjjjHGSusdfsd'

export default {
  //加密
  encrypt: value => {
    if(!value) return value
    return CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value), key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }).toString()
  },

  //解密
  decrypt: value => {
    if(!value) return value
    return CryptoJS.enc.Utf8.stringify(CryptoJS.AES.decrypt(value, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })).toString()
  }
}